import React, { useState, useEffect } from 'react';
import { Card, Table, Tag, message } from 'antd';
import { serverAPI } from '../services/api';
import type { NodeInfo } from '../types';
import dayjs from 'dayjs';

export const Nodes: React.FC = () => {
  const [nodeList, setNodeList] = useState<NodeInfo[]>([]);
  const [loading, setLoading] = useState(false);
  const [windowWidth, setWindowWidth] = useState(window.innerWidth);

  // 获取节点列表数据
  const fetchNodeList = async () => {
    try {
      setLoading(true);
      const response = await serverAPI.getServers();
      setNodeList(response.data.data);
    } catch (error) {
      console.error('Failed to fetch node list:', error);
      message.error('获取节点列表失败');
      setNodeList([]);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchNodeList();

    // 监听窗口大小变化
    const handleResize = () => {
      setWindowWidth(window.innerWidth);
    };
    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  const getColumns = () => {
    const baseColumns = [
      {
        title: '节点名称',
        dataIndex: 'name',
        key: 'name',
      },
      {
        title: '状态',
        dataIndex: 'is_online',
        key: 'is_online',
        render: (is_online: number) => (
          <Tag color={is_online === 1 ? 'success' : 'error'}>
            {is_online === 1 ? '在线' : '离线'}
          </Tag>
        ),
      },
    ];

    const additionalColumns = [
      //最新检查时间
      {
        title: '检查时间',
        dataIndex: 'last_check_at',
        key: 'last_check_at',
        render: (last_check_at: string) => dayjs(Number(last_check_at)*1000 ).format('YYYY-MM-DD HH:mm:ss'),
      },
      {
        title: '倍率',
        dataIndex: 'rate',
        key: 'rate',
        render: (rate: string) => `${rate} x`,
      },
      {
        title: '标签',
        dataIndex: 'tags',
        key: 'tags',
        render: (tags: string[]) => (
          <>
            {tags && tags.map((tag) => (
              <Tag color="blue" key={tag}>
                {tag}
              </Tag>
            ))}
          </>
        ),
      },
    ];

    return windowWidth <= 576 ? baseColumns : [...baseColumns, ...additionalColumns];
  };

  return (
    <div className="px-4 sm:px-6 lg:px-8">
      <div className="mb-8">
        <h1 className="text-2xl font-bold text-gray-900 dark:text-white transition-colors">节点状态</h1>
        <p className="mt-1 text-sm text-gray-600 dark:text-gray-400 transition-colors">
          实时查看可用节点状态与基础信息。
        </p>
      </div>
      <Card>
        <Table
          columns={getColumns()}
          dataSource={nodeList}
          rowKey="id"
          loading={loading}
          pagination={false}
        />
      </Card>
    </div>
  );
};

// export default Nodes;
